import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import {
  permitTemplateKeys,
  RequestTypes,
} from '@core/react-query/features/templates/permitTemplates/permitTemplate'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { foldersKeys } from '@core/react-query/features/folders'

export const useCreatePermitTemplate = (
  options?: UseMutationOptions<
    unknown,
    RequestErrorType,
    RequestTypes['createPermitTemplate']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...permitTemplateKeys.createPermitTemplate,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: foldersKeys._def,
      })
    },
    ...options,
  })
}
